
import { Vue } from 'vue-class-component'
export default class LoadingButton extends Vue {}
